import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import spinner from '../../../FO/resources/img/loading.svg';

class Spinner extends Component {

    render() {
        return (
            <Fragment>
                {this.props.loading !== 0 ? 
                <div className="cinemap-spinner">
                    <img src={spinner} alt="Loading"/>                    
                </div> : ""
                }
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.loading.pendingRequests
});
export default connect(mapStateToProps, {})(Spinner);





// WEBPACK FOOTER //
// ./src/SHARED/components/spinner/spinner.component.js